import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import _ from 'lodash';
import {Can} from "../../ability-context";

import createLink from "../../libs/createLink";

import {fetchAlbumMediasMulti, resetAlbumMediasMulti} from "../../creators/album.medias-multi";
import {mediasByAlbumId} from "../../selectors/medias";
import {reportAlbum} from "../../creators/report";

import Report from './Report';
import Thumb from './Thumb';
import DateSince from './Date';
import AlbumInformations from "./AlbumInformations";
import {Button} from "./Button";
import Title from "./Title";
import Modal from "./Modal";
import ContentLoader from "react-content-loader";
import Authenticated from "../../libs/Authenticated";

class AlbumGrid extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            byAlbumId: this.props._id,
            //sort: this.props.order || "-createdAt",
            limit: 5,
            isTotal : false
        };
        /*if(!this.props.isMe){
            this.filter = {
                ...this.filter,
                'file.state' : 1
            }
        }*/
        this.state = {
            toggle: false,
            isPublic: this.props.isPublic,
            userId: this.props.match && (this.props.match.params.userId || (this.props.user && this.props.user._id)),
            userSlug: this.props.match && (this.props.match.params.userSlug || (this.props.user && this.props.user.slug)),
            filter: this.filter
        };
        this.handleReport = this.handleReport.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.props.fetchAlbumMediasMulti(this.props._id, this.state.filter);
    }

    componentDidUpdate(prevProps) {
        if(this.props.order !== prevProps.order){
            //let filter = {...this.state.filter, sort : this.props.order};
            //this.setState({filter});
            this.props.fetchAlbumMediasMulti(this.props._id, this.state.filter);
        }
    }

    handleClose() {
        this.setState({toggle: false});
    }

    handleReport(message){
        this.props.reportAlbum(this.props._id, {message})
    }

    render() {
        let linkAlbum = createLink('userAlbum', {...this.props.user, album : {_id : this.props._id, slug : this.props.slug}});
        return (
            <div className="album-grid">
                <div className="topline-album">
                    <div className="album-title">
                        {this.props.isMe ? (
                            <Link to={createLink('userMeAlbum', {...this.props.user, album : {_id : this.props._id, slug : this.props.slug}})}>
                                <Title heading={"heading-3"} display={"display-3"}>
                                    {(this.props.right === "private" || this.props.right === "friends") && <div
                                        className="badge red-reverse private">{this.props.right === "private" ? 'Privé' : this.props.right === "friends" && 'Amis'}</div>}
                                    {this.props.right === "public" && (
                                        <div className="badge red-reverse private">Voissanautes</div>
                                    )}
                                    {this.props.title}
                                </Title>
                            </Link>
                        ) : (
                            <Link to={linkAlbum}>
                                <Title heading={"heading-3"} display={"display-3"}>
                                    {(this.props.right === "private" || this.props.right === "friends") && <div
                                        className="badge red-reverse private">{this.props.right === "private" ? 'Privé' : this.props.right === "friends" && 'Amis'}</div>}
                                    {this.props.title}
                                </Title>
                            </Link>
                        )}
                        <Can action={"update"} subject={this.props} modelName={"Album"}>
                            <div className="row">
                                <Button className={"edit-album"}
                                        btnStyle={"edit"}
                                        corner={"btn-rounded-corner"}
                                        size={"small"}
                                        onClick={() => this.setState({toggle: true})}
                                        content={"Editer l'album"}/>
                                <Modal toggle={this.state.toggle} handleClose={() => this.handleClose()}>
                                    <AlbumInformations handleClose={this.handleClose}
                                                       editAlbum={true}
                                                       userId={this.props.user._id}
                                                       handleRender={this.props.handleRender}
                                                       currentAlbumId={this.props._id}/>
                                </Modal>
                            </div>
                        </Can>
                    </div>
                    <span className="last-album-update">
                        {this.props.count.photo} photo{this.props.count.photo > 1 ? 's' : ''} et {this.props.count.video} vidéo{this.props.count.video > 1 ? 's' : ''}
                        &nbsp;-&nbsp;
                        Mis à jour&nbsp;
                        <DateSince
                            date={this.props.updatedAt}
                            prefix={true}
                            currentFormat={true}
                        />
                    </span>
                </div>
                <div className="album">
                    <div className="wrapper-album">
                        {!this.props.albumMediasInitialized || this.props.albumMediasLoading ?(
                            <div className="wrapper-thumb album-preview">
                                {_.times(5).map((item, index) => (
                                    <div className={"thumb"} key={index}>
                                        <ContentLoader
                                            height={200}
                                            width={180}
                                            speed={2}
                                            primaryColor="#f3f3f3"
                                            secondaryColor="#ecebeb"
                                        >
                                        </ContentLoader>
                                    </div>
                                ))}
                            </div>
                            ) : (
                            <div className="wrapper-thumb album-preview">
                                {Array.isArray(this.props.albumMedias) && this.props.albumMedias.slice(0,5).map((media, index) => (
                                    <Thumb key={`${media._id}_${index}`} isMe={this.props.isMe} {...media} cropTitle={55}/>
                                ))}
                                {this.props.albumMediasTotal === 0 && (
                                    <span className="no-content">Il n'y a pas de média dans cet album</span>
                                )}
                            </div>
                        )}

                    </div>
                </div>
                <div className="baseline-album">
                    {this.props.user && !this.props.isMe && (
                        <Authenticated passThrough>
                            {(authenticated) => {
                                return authenticated && <Report _id={this.props._id}
                                                                kind={"albums"}
                                                                type={"button"}
                                                                handleReport={this.handleReport}
                                                                title={this.props.title}/>
                            }}
                        </Authenticated>
                    )}
                    <Link to={this.props.isMe && (this.props.user._id === this.props.owner._id) ? (
                        createLink('userMeAlbum', {...this.props.user, album : {_id : this.props._id, slug : this.props.slug}})
                    ) : (
                        linkAlbum
                    )}>
                        <Button size={"small"}
                                btnStyle={"primary-reverse"}
                                content={"Voir tout le contenu de l'album"}/>
                    </Link>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    let mediaByAlbum = mediasByAlbumId(state, props);
    return {
        albumMedias: mediaByAlbum.data,
        albumMediasLoading: mediasByAlbumId(state, props).loading,
        albumMediasInitialized: mediasByAlbumId(state, props).initialized,
        albumMediasTotal: _.get(mediaByAlbum, "data.length") || 0
    }
};


const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchAlbumMediasMulti,
    resetAlbumMediasMulti,

    reportAlbum,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AlbumGrid);
